import { useQuery } from '@tanstack/react-query'
import { getLuckyWheelImagePresets } from '../../services'
import { LuckyWheelQueryKeys } from '../../../keys'
import type { GetLuckyWheelImagePresetsResponse } from '../../../type'

export default function useQueryGetLuckyWheelImagePresets(
	type?: 'wheel' | 'arrow',
) {
	return useQuery<GetLuckyWheelImagePresetsResponse>({
		queryKey: [LuckyWheelQueryKeys.GetLuckyWheelImagePresets, type],
		queryFn: () => getLuckyWheelImagePresets(type),
	})
}
